import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SupportService } from 'src/app/service/common/support.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  company : any;

  constructor(
    private supportService : SupportService
  ) { }

  ngOnInit(): void {
    this._subs.add(
      this.supportService.getCompanyDetails().subscribe(res => {
        this.company = res.data;
      })
    )
  }

  uploadLogo(data){}

}
